// removed by extract-text-webpack-plugin
module.exports = {"form":"c-PasswordRecoveryForm__form","button":"c-PasswordRecoveryForm__button"};